import { _ } from '@ngx-translate/core';

export const NEW_USERS_HINT = _('components.hint.constants.newUsersHint');

export const MAIL_HINT = _('components.hint.constants.mailHint');
